module.exports = __webpack_public_path__ + "img/figure4.dfec22c6.png";